import { render, staticRenderFns } from "./FedExInvoiceStep.vue?vue&type=template&id=68f96e50&scoped=true"
import script from "./FedExInvoiceStep.vue?vue&type=script&lang=ts"
export * from "./FedExInvoiceStep.vue?vue&type=script&lang=ts"
import style0 from "./FedExInvoiceStep.vue?vue&type=style&index=0&id=68f96e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f96e50",
  null
  
)

export default component.exports